import * as React from "react";
import type { SVGProps } from "react";
const LandscapeFilterIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"
    {...props}>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M337.5 0H0.5V71H337.5V0ZM337.5 266H0.5V337H337.5V266Z" fill="black" fill-opacity="0.5"/>
    </svg>
);
export default LandscapeFilterIcon;
